<div class="img-container">
    <media-image [media]="artist"></media-image>
    <playback-control-button (play)="play()" (pause)="pause()" [playing]="playing()"></playback-control-button>
</div>
<div class="footer">
    <artists-links-list class="artist-name primary-text" [artists]="[artist]"></artists-links-list>
</div>